import React from 'react';
import { BookOpen, HelpCircle, ShoppingCart, ArrowRight } from 'lucide-react';
import { useLang } from '../i18n';

const GUIDES = [
  {
    slug: 'how-to-create-a-barcode',
    icon: BookOpen,
    de: { title: 'Barcode erstellen – Schritt für Schritt', desc: 'Vom Zahlencode zum fertigen Barcode: Typ wählen, Wert eingeben, exportieren.' },
    en: { title: 'Create a barcode – step by step', desc: 'From number to finished barcode: pick a type, enter the value, export.' },
  },
  {
    slug: 'which-barcode-for-what-purpose',
    icon: HelpCircle,
    de: { title: 'Welcher Barcode für welchen Zweck?', desc: 'Handel, Logistik, 2D oder Pharma – so findest du den richtigen Codetyp.' },
    en: { title: 'Which barcode for which purpose?', desc: 'Retail, logistics, 2D or pharma – find the right code type fast.' },
  },
  {
    slug: 'barcodes-for-amazon-ebay-google',
    icon: ShoppingCart,
    de: { title: 'Barcodes für Amazon, eBay & Google', desc: 'GTIN/EAN für Marktplätze: was du brauchst und wie du den Code erzeugst.' },
    en: { title: 'Barcodes for Amazon, eBay & Google', desc: 'GTIN/EAN for marketplaces: what you need and how to create the code.' },
  },
];

export const GuideTeasers = ({ className = '' }) => {
  const { lang } = useLang();
  const isDe = lang !== 'en';
  const base = isDe ? '' : '/en';
  const allHref = isDe ? '/ratgeber/' : '/en/guides/';

  return (
    <section className={className} aria-label={isDe ? 'Ratgeber' : 'Guides'} data-testid="home-guide-teasers">
      <div className="mb-4 flex items-end justify-between gap-3">
        <div>
          <h2 className="text-xl font-semibold tracking-tight text-foreground sm:text-2xl">
            {isDe ? 'Ratgeber & Tipps' : 'Guides & tips'}
          </h2>
          <p className="mt-1 text-sm text-muted-foreground">
            {isDe ? 'Hilfreiche Anleitungen rund um Barcodes.' : 'Helpful how-tos all about barcodes.'}
          </p>
        </div>
        <a
          href={allHref}
          data-testid="home-guides-all-link"
          className="inline-flex shrink-0 items-center gap-1 text-sm font-medium text-primary underline-offset-4 transition-colors duration-150 hover:underline"
        >
          {isDe ? 'Alle Ratgeber' : 'All guides'}
          <ArrowRight className="h-4 w-4" />
        </a>
      </div>

      <div className="grid gap-4 sm:grid-cols-2 lg:grid-cols-3">
        {GUIDES.map((g) => {
          const c = isDe ? g.de : g.en;
          const Icon = g.icon;
          return (
            <a
              key={g.slug}
              href={`${base}/${g.slug}/`}
              data-testid={`home-guide-${g.slug}`}
              className="group flex flex-col rounded-xl border bg-card p-5 shadow-sm transition-all duration-150 hover:-translate-y-0.5 hover:border-primary/40 hover:shadow-md focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring"
            >
              <span className="mb-3 inline-flex h-10 w-10 items-center justify-center rounded-lg bg-primary/10 text-primary">
                <Icon className="h-5 w-5" />
              </span>
              <h3 className="text-base font-semibold text-foreground">{c.title}</h3>
              <p className="mt-1 flex-1 text-sm text-muted-foreground">{c.desc}</p>
              <span className="mt-3 inline-flex items-center gap-1 text-sm font-medium text-primary">
                {isDe ? 'Ratgeber lesen' : 'Read guide'}
                <ArrowRight className="h-4 w-4 transition-transform duration-150 group-hover:translate-x-0.5" />
              </span>
            </a>
          );
        })}
      </div>
    </section>
  );
};
